define([
    "./core",
    "./browser",
    "./css",
    "./datax",
    "./dnd",
    "./eventer",
    "./filer",
    "./finder",
    "./fx",
    "./geom",
    "./http",
    "./mover",
    "./noder",
    "./query",
    "./scripter",
    "./styler",
    "./velm"
], function(skylark) {
    return skylark;
})
